// Prefer an explicit env override, otherwise default to the current origin (keeps the same protocol, e.g. https)
const envBase =
  process.env?.REACT_APP_API_BASE ||
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_BASE) ||
  process.env?.VITE_API_BASE;

const rawBase = envBase || (typeof window !== "undefined" ? window.location.origin : "https://news-demo.dataflock.de");

// Normalise to avoid trailing slashes duplicating when composing URLs.
const API_BASE = rawBase.replace(/\/+$/, '');
const API_BASE_URL = `${API_BASE}/api`;

/**
 * Compose a full API URL from the configured base.
 * Accepts paths with or without a leading slash.
 */
export const apiUrl = (path = '') => {
  if (!path) {
    return API_BASE;
  }

  const normalisedPath = `${path}`.replace(/^\/+/, '');
  return `${API_BASE}/${normalisedPath}`;
};

/**
 * Compose a full API URL rooted at /api from the configured base.
 * Accepts paths with or without a leading slash.
 */
export const apiBaseUrl = (path = '') => {
  if (!path) {
    return API_BASE_URL;
  }

  const normalisedPath = `${path}`.replace(/^\/+/, '');
  return `${API_BASE_URL}/${normalisedPath}`;
};

export default API_BASE;
export { API_BASE_URL };
